import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';

export interface TopBlockPropsType {
    newBillsOfMaterials: boolean;
    disableEdit: boolean;
    handleSave: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        label: translate(
                            props.newBillsOfMaterials
                                ? 'billOfMaterialsDetail.action.create'
                                : 'billOfMaterialsDetail.action.save'
                        ),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
